<template>
  <Transition name="fade">
    <div class="ah-overlay" />
  </Transition>
</template>

<script>
  export default {
    name: 'AhOverlay',
  };
</script>
